import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import FooterSpy from "./footerSpylink";

import linkedin from "assets/images/logo/linkd.png";
import fb from "assets/images/logo/face.png";
import youtube from "assets/images/logo/yt.png";
import twitter from "assets/images/logo/twit.png";
import logo from "assets/images/logo/logo.png";
import { eventTrack } from "helpers/ga4Helper";
import { PRIGMAR_SOCIAL, PRIGMAR_PHONE, PRIGMAR_PHONE_TEL } from "./prigmarContact";

const openInNewTab = (url) => {
  window.open(url, "_blank", "noopener,noreferrer");
};
const FooterComponent = () => {
  const location = useLocation();

  return (
    <>
      <div className="footer pt-2 pb-2">
        <div className="footer-container mt-5 mb-3">
          <div className="row">
            <div className="col-md-4">
              <div className="d-flex align-items-baseline">
                <img src={logo} className="footer-logo" alt="prigmar Logo" />
                <span
                  className="logo-title-footer"
                  style={{ color: "#000000 !important" }}
                >
                  <b className="footer-logo-title">
                  Prigmar 
                  </b>
                </span>
              </div>
              <p className="footer-desc">
              Prigmar is a content creation and scheduling platform that helps brands and businesses grow organically through social media and SEO.
              Prigmar provides automated content and scheduling that outperforms traditional counterparts <br />
                reach out to us.
              </p>
              <div className="footer-social-container">
                <a
                  href={PRIGMAR_SOCIAL.facebook}
                  target="blank"
                  onClick={eventTrack(
                    "Navigate-Facebook-Action",
                    "Navigate-Facebook",
                    "Navigate-Facebook",
                    "+1",
                    false,
                    "+1"
                  )}
                >
                  <img src={fb} />
                </a>
                <a
                  href={PRIGMAR_SOCIAL.twitter}
                  target="blank"
                  onClick={eventTrack(
                    "Navigate-Twitter-Action",
                    "Navigate-Twitter",
                    "Navigate-Twitter",
                    "+1",
                    false,
                    "+1"
                  )}
                >
                  <img src={twitter} />
                </a>
                <a
                  href={PRIGMAR_SOCIAL.linkedin}
                  target="blank"
                  onClick={eventTrack(
                    "Navigate-Linkedin-Action",
                    "Navigate-Linkedin",
                    "Navigate-Linkedin",
                    "+1",
                    false,
                    "+1"
                  )}
                >
                  <img src={linkedin} />
                </a>
                <a
                  href={PRIGMAR_SOCIAL.youtube}
                  target="blank"
                  onClick={eventTrack(
                    "Navigate-Youtube-Action",
                    "Navigate-Youtube",
                    "Navigate-Youtube",
                    "+1",
                    false,
                    "+1"
                  )}
                >
                  <img src={youtube} />
                </a>
              </div>
            </div>
            <div className="col-md-8">
              {location.pathname !== "/personal-area" ? (
                <div className="row">
                  <div className="col-md-3"></div>
                  <div className="col-md-5">
                    <p className="footer-head">Useful Links</p>
                    <FooterSpy />
                  </div>
                  <div className="col-md-4">
                    <p className="footer-head">Contact</p>
                    <div className="footer-links-div">
                      <a href={PRIGMAR_PHONE_TEL}>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                          />
                        </svg>{" "}
                        {PRIGMAR_PHONE}
                      </a>
                      <Link to="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                        support@prigmar.com
                      </Link>
                      <Link to="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                        64 E Broadway Rd, Suite 200 Tempe, AZ 85281
                      </Link>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-4">
                    <p className="footer-head">Contact</p>
                    <div className="footer-links-div">
                      <a href={PRIGMAR_PHONE_TEL}>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                          />
                        </svg>{" "}
                        {PRIGMAR_PHONE}
                      </a>
                      <Link to="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                        support@prigmar.com
                      </Link>
                      <Link to="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                        64 E Broadway Rd, Suite 200 Tempe, AZ 85281
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <p className="all-right-reserve">
          <div className="border-top border-color-light-white py-4">
        <div className="container">
          <p className="text-white mb-0 text-center font-weight-300">
          <img
        src="https://prigmar.com/img/logos/favicon-white.png"
        alt="Icon Logo"
        className="w-2 h-2"
      />
          &nbsp; Prigmar is a product of
          
          <span className="text-secondary text-white-hover ms-1">
          <img
        src="https://prigmar.com/img/logos/favicon-white-old.png"
        alt="Icon Logo"
        className="w-2 h-2"
      />&nbsp;BidLight, INC
            </span>
            &nbsp;| All rights reserved by
            <span className="text-secondary text-white-hover ms-1">
             BidLight.
            </span>
            &copy;<span className="current-year"></span>
          </p>
        </div>
      </div>
          </p>
        </div>
      </div>
    </>
  );
};

export default FooterComponent;
